import type { UserType } from '@prisma/client';

/**
 * One Glaze hue per job role, so a person reads the same in the list, Quick and
 * the preview. Blue is left out: it means "selected". Full class strings, so
 * Tailwind sees them.
 */
export const ROLE_TONE: Record<UserType, { avatar: string; text: string; dot: string }> = {
  POST_SALES: { avatar: 'bg-bg-teal text-text-teal', text: 'text-text-teal', dot: 'bg-text-teal' },
  PRE_SALES: { avatar: 'bg-bg-purple text-text-purple', text: 'text-text-purple', dot: 'bg-text-purple' },
  SDR: { avatar: 'bg-bg-orange text-text-orange', text: 'text-text-orange', dot: 'bg-text-orange' },
  REVOPS: { avatar: 'bg-bg-pink text-text-pink', text: 'text-text-pink', dot: 'bg-text-pink' },
  MEMBER: { avatar: 'bg-bg-grey text-content-secondary', text: 'text-content-secondary', dot: 'bg-content-tertiary' },
};
